import React from 'react';
import { CheckCircle2 } from 'lucide-react';

/**
 * CancellationBanner — visual reassurance banner.
 * Purely presentational. No cancellation logic.
 */
export function CancellationBanner({ t, testIdSuffix = 'default' }) {
  const tr = (key, fallback) => (t ? (t(key) || fallback) : fallback);
  return (
    <div
      className="mt-2 flex items-start gap-2 rounded-lg bg-emerald-50 border border-emerald-100 px-3 py-2 text-[11px] text-emerald-800"
      data-testid={`cancellation-banner-${testIdSuffix}`}
    >
      <CheckCircle2 size={14} className="text-emerald-600 mt-0.5 shrink-0" />
      <span>
        {tr(
          'trust_cancellation_full',
          'Kostenlose Stornierung bis 24h vor Abholung – 100% Geld-zurück-Garantie.'
        )}
      </span>
    </div>
  );
}
